window.addEventListener("DOMContentLoaded", (event) => {
  function removeClass(elements, attr) {
    // it takes all the elements and class
    elements.forEach((element) => {
      element.classList.remove(attr);
    });
  }

  var btnImages = document.querySelectorAll(".cg-i-image");
  btnImages.forEach((btnImg) => {
    btnImg.addEventListener("click", function () {
      let imageID = btnImg.getAttribute("data-image-id");
      let productID = btnImg.getAttribute("data-product-id");
      let sameBtnImages = document.querySelectorAll(
        `.cg-i-image[data-product-id='${productID}']`
      );
      console.log("Image ID", imageID, "Product ID", productID);
      removeClass(sameBtnImages, "active-i");
      let mainImages = document.querySelectorAll(
        `.cg_image-main[data-product-id='${productID}']`
      );
      //console.log('main images',mainImages);
      removeClass(mainImages, "active-i");
      let sameMainImage = document.querySelector(
        `.cg_image-main[data-image-id='${imageID}']`
      );
      sameMainImage.classList.add("active-i");
      btnImg.classList.add("active-i");
    });
  });

  // Popup
  var quoteBtns = document.querySelectorAll(".cg-quote-btn");
  var overlay = document.querySelector(".base-overlay");
  var container = document.querySelector(".base--main-container");
  var inputField = document.querySelector("#fill-input");
  var hideBtn = document.querySelector(".hide-btn");
  var body = document.querySelector("body");
  hideBtn.addEventListener("click", function () {
    overlay.style.display = "none";
    container.style.display = "none";
    body.style.overflow = "";
  });
  //console.log('btns',quoteBtns)
  quoteBtns.forEach((btn) => {
    btn.addEventListener("click", function () {
      console.log("clicked");
      let title = btn.getAttribute("data-product-title");
      let image = btn.getAttribute("data-product-image");
      let url = btn.getAttribute("data-product-url");
      console.log("title", title, "image", image, "url", url);
      overlay.style.display = "block";
      container.style.display = "block";
      body.style.overflow = "hidden";
      inputField.setAttribute(
        "value",
        `Quote for Product ${title} .  ${image}       ${url}`
      );
    });
  });
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  if (urlParams.has("contact_posted")) {
    overlay.style.display = "block";
    container.style.display = "block";
    body.style.overflow = "hidden";
  }

  //btnImg.addEventListener('click',function(){
  // quoteBtn.addEventListener('click',function (){
  //   console.log('clicked')
  // }) ?contact_posted=true#contact-302073348256
});
